/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'
import * as Yup from 'yup'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useChangeEmailAddressMutation } from 'api/account'
import { ChangeEmailAddress } from 'models/account'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    form: RefObject<FormikProps<ChangeEmailAddress>>
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function ChangeEmailAddressForm({ form }: Props) {
    const [changeEmailAddress] = useChangeEmailAddressMutation({ fixedCacheKey: 'change-email-address' })

    return (
        <Formik
            innerRef={form}
            initialValues={{
                new_email: '',
                confirm_new_email: '',
                password: ''
            }}
            validationSchema={
                Yup.object({
                    new_email: Yup.string()
                        .email('Invalid email address')
                        .required('Required'),
                    confirm_new_email: Yup.string()
                        .oneOf([Yup.ref('new_email'), null], 'Email must match')
                        .required('Required'),
                    password: Yup.string()
                        .required('Required')
                })
            }
            onSubmit={({ new_email, password }) => {
                changeEmailAddress({ new_email, password })
            }}
        >
            {({ isSubmitting }) => (
                <Form id={'changeEmailAddressForm'}>
                    <Field
                        label={'New Email Address'}
                        name={'new_email'}
                        type={'email'}
                        disabled={isSubmitting}
                        autoComplete={'email'}
                        component={NXUIForm.InputField}
                    />
                    <Field
                        label={'Confirm New Email Address'}
                        name={'confirm_new_email'}
                        type={'email'}
                        disabled={isSubmitting}
                        autoComplete={'email'}
                        component={NXUIForm.InputField}
                    />
                    <Field
                        label={'Password'}
                        name={'password'}
                        type={'password'}
                        disabled={isSubmitting}
                        autoComplete={'current-password'}
                        component={NXUIForm.InputField}
                    />
                </Form>
            )}
        </Formik>
    )
}
